import { useTranslation } from 'react-i18next';

/**
 * Configuration content (stages, steps, document rules, categories, schemes, bank fields) carries an English label and
 * an optional Arabic one entered by the administrator. Arabic UI shows the Arabic label when it exists; otherwise the
 * English label as written. Codes and keys are never used as labels.
 */
export function configLabel(en: string, ar: string | null | undefined, language: string): string {
  return language.split('-')[0] === 'ar' && ar?.trim() ? ar : en;
}

/** `const label = useConfigLabel(); label(step.name, step.nameAr)` */
export function useConfigLabel() {
  const { i18n } = useTranslation();
  return (en: string, ar?: string | null) => configLabel(en, ar, i18n.language);
}
